import { buildSgPresetPrepareDocumentItem } from '../../presetDocCustSave';
import { isOfficerWithdrawPresetDocument } from '../../appoint-director/composables/appointDirectorSigners';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
}

export function buildWithdrawSecretaryPresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  commonFormData: Record<string, any>;
  personName: string;
  entityCd?: string;
  /** DR (Withdraw Secretary) / Resignation Letter — 해임 대상 자동 사이너 JSON */
  withdrawingOfficerSignersJson?: string;
}) {
  return (input.selectionDocuments || [])
    .filter((d) => d.tmpId)
    .map((d) => {
      const templateName = d.templateName || '';
      const useOfficerSigner =
        !!input.withdrawingOfficerSignersJson && isOfficerWithdrawPresetDocument(templateName);
      const commonFormData = useOfficerSigner
        ? {
            ...input.commonFormData,
            signers: input.withdrawingOfficerSignersJson,
            Signers: input.withdrawingOfficerSignersJson,
          }
        : { ...input.commonFormData };

      return buildSgPresetPrepareDocumentItem({
        templateId: d.tmpId as number | string,
        templateName,
        personName: input.personName,
        commonFormData,
        entityCd: input.entityCd,
      });
    });
}
